import React, { useEffect, useState } from 'react';

import { Box, Button, Card, Divider, Grid, TextField, Theme, Typography, Paper } from '@mui/material'

import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PinDropIcon from '@mui/icons-material/PinDrop';
import MovieIcon from '@mui/icons-material/Movie';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Link as RouterLink, useHistory, useParams } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { LogoOnly } from '@shared/components/LogoOnly';
import { AppContainer } from '@shared/components/AppContainer';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getTokenAction, tokenSelector } from '@store/slices/token.slice';
import { CURRENCIES, CURRENCY } from '@shared/constants/app.constant';
import { TextFieldAdornment } from '@shared/components/TextFieldAdornment';
import { currencyConversion, getCurrencySymbol, getOtherCurrency } from '@shared/helpers/global.helper';
import { tokenService } from '@services/token.service';
import ListingSuccessImage from '@assets/images/post-listing-sucess.png';
import QuestionMakrImage from '@assets/images/Vectorquestionmark.png';
import ListingInfoImage from '@assets/images/listing-info.png';
import InfoIcon from '@mui/icons-material/Info';
import AlertDialog from '@shared/components/AlertDialog';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { appSelector } from '@store/slices/app.slice';

const useStyles = makeStyles((theme: Theme) => ({
    white: {
        backgroundColor: theme.palette.background.paper,
    },
    dark: {
        color: '#64748B'
    },
    header: {
        marginBottom: '8px'
    },
    green: {
        color: 'green'
    },
    chip: {
        height: '20px !important', width: '100px',
        background: 'rgba(0, 159, 77, 0.1) !important',
        color: '#009F4D !important'
    },
    tooltipIcon: {},
    summary: {
        padding: '15px'
    },
    currency: {
        fontSize: '16px !important',
        fontStyle: 'normal !important',
        lineHeight: '31px !important',
        letterSpacing: '0.005em !important'
    }
}));

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: 200,
        backgroundColor: 'white', color: 'black', fontSize: 'small'
    },
});

export const CustomerSellToken = () => {
    const classes = useStyles();
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [confirmation, setConfirmation] = useState(false);
    const [currency, setCurrency] = useState(CURRENCY.USD);
    const tokenDetails = useAppSelector(tokenSelector);
    const [amount, setAmount] = useState<any>('');
    const appSlice = useAppSelector(appSelector)
    const history = useHistory();
    const commissionTooltip = "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries"
    const transactionFeeTooltip = "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries"
    const dispatch = useAppDispatch();
    let { id } = useParams<{ id: string }>();

    const onSubmit = async () => {
        let amountToCompare = tokenDetails?.token?.listing_amount;
        //if currency is changed to other than token currency
        if (currency !== tokenDetails?.token?.profile?.currency) {
            amountToCompare = Number(currencyConversion(getOtherCurrency(tokenDetails?.token?.profile?.currency), tokenDetails?.token?.listing_amount, appSlice.USD_TO_ETH_VALUE));
        }
        if ((!amount || Number(amount) < Number(amountToCompare))) {
            setError(true)
            return;
        }
        setConfirmation(true)

    }
    const onSellToken = async () => {
        setConfirmation(false)
        let newAmount = amount;
        //if currency is changed to other than token currency
        if (currency !== tokenDetails?.token?.profile?.currency) {
            newAmount = Number(currencyConversion(getOtherCurrency(currency), amount, appSlice.USD_TO_ETH_VALUE));
        }
        const response = await tokenService.sellToken(tokenDetails?.token?.id, newAmount);
        setSuccess(true)
    }

    const onClose = () => {
        setSuccess(false)
        history.push(`/tokens`);
    }

    const calculateAmount = () => {
        if (!amount || Number(amount) < tokenDetails?.token?.listing_amount) return tokenDetails?.token?.total_amount;

        const total = Number(amount) + Number(getTransactionFee()) + Number(getCommisionFee());
        return Number(total.toFixed(2))
    }

    const getCommisionFee = () => {
        if (!amount || Number(amount) < tokenDetails?.token?.listing_amount) return tokenDetails?.token?.commission_amount;
        return Number((Number(amount) * (tokenDetails?.token?.commission_percentage / 100)).toFixed(2))
    }
    const getTransactionFee = () => {
        if (!amount || Number(amount) < tokenDetails?.token?.listing_amount) return tokenDetails?.token?.transaction_amount;
        return Number((Number(amount) * (tokenDetails?.token?.transaction_percentage / 100)).toFixed(2))
    }

    useEffect(() => {
        if (id) {
            dispatch(getTokenAction(id))
        }
    }, [])

    const convertedPrice = currencyConversion(getOtherCurrency(currency), amount, appSlice.USD_TO_ETH_VALUE)

    const breadcrumbs = [
        <Link key="1" component={RouterLink} to="/tokens" color="inherit"  >
            My Membership NFTs
        </Link>,
        <Link key="1" component={RouterLink} to={`/tokens/${tokenDetails.token.id}?owned=${true}`} color="inherit"  >
            {tokenDetails.token.profile?.title}
        </Link>,
        <Link key="1" color="inherit" style={{ textDecoration: 'none' }}>
            <strong>Sell Membership NFT</strong>
        </Link>
    ];

    return (
        <AppContainer>
            <Box mb={6}>
                <Breadcrumbs separator="›" aria-label="breadcrumb">
                    {breadcrumbs}
                </Breadcrumbs>
            </Box>
            <AlertDialog open={error} image={
                <img src={ListingInfoImage} alt="Warning" height="190px" />
            } >
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    <strong>Price below asking price</strong>
                </Typography>
                <Typography id="modal-modal-title" variant="caption">
                    Price below asking price is not allowed. Please enter a price again
                </Typography>

                <Box my={3} width={1}>
                    <Box width={1} > <Button style={{ backgroundColor: '#041E42', width: "100%" }} variant="contained" onClick={() => setError(false)} size="small" color="primary"  >Re-enter price</Button></Box>
                </Box>
            </AlertDialog>
            <AlertDialog open={success} image={
                <img src={ListingSuccessImage} alt="Success" />
            } >
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    <strong>Membership NFT Successfully Listed</strong>
                </Typography>
                <Typography id="modal-modal-title" variant="caption">
                    We will notify you when your Membership NFT sells.
                </Typography>

                <Box my={3} width={1}>
                    <Box width={1} > <Button style={{ backgroundColor: '#041E42', width: "100%" }} variant="contained" onClick={() => onClose()} size="small" color="primary"  >Close</Button></Box>
                </Box>
            </AlertDialog>
            <AlertDialog open={confirmation} image={
                <InfoIcon style={{ fontSize: 'xx-large' }} />
            } >
                <Box p={4} textAlign="center">
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        <strong>Sell Membership NFT</strong>
                    </Typography>
                    <Typography id="modal-modal-title" variant="body1" className="grey-color">
                        Stakes uses cryptocurrency in making all transactions Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </Typography>
                    <Box my={3} width={1}>
                        <Box width={1} >
                            <Button style={{ backgroundColor: '#041E42', width: "100%" }} variant="contained" onClick={() => onSellToken()} size="small" color="primary"  >Continue</Button> &nbsp;
                            <Button style={{ width: "100%" }} variant="outlined" onClick={() => setConfirmation(false)} size="small" color="primary"  >Close</Button> &nbsp;
                            <Box className="flex-justify-center">
                                <Button color="primary" component={RouterLink} to="/help-center">
                                    Need help? Go to Help Center
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </AlertDialog>
            <Grid container spacing={3}>
                <Grid item md={1}></Grid>
                <Box mb={2} sx={{ ml: { xs: 0, md: 3 } }}>
                    <Typography variant="h4">
                        <strong>Sell Membership NFT</strong>
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={3}>
                <Grid item md={1}></Grid>
                <Grid item md={6} xs={12} >
                    <Card sx={{ padding: '16px' }}>
                        <Box mb={6}>
                            <LogoOnly style={{ height: '35px', marginBottom: '24px' }} />
                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                                <Typography fontWeight={700} className='title2' color='#1E293B'>
                                    {tokenDetails.token.profile?.title}
                                </Typography>
                            </Box>
                            <Box display="flex" alignItems="center" justifyContent="flex-start">
                                <Box display="flex" marginRight="15px" alignItems="center" className={`${classes.dark}`}>
                                    <PersonOutlineIcon />
                                    <Typography className={`body2`} ml={1}>
                                        {tokenDetails?.token?.business?.name}
                                    </Typography>
                                </Box>
                                <Box display="flex" marginRight="15px" alignItems="center" className={`${classes.dark}`}>
                                    <PinDropIcon />
                                    <Typography className={`body2`} ml={1}>
                                        {tokenDetails?.token?.business?.city}, {tokenDetails?.token?.business?.state}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" className={`${classes.dark}`}>
                                    <MovieIcon />
                                    <Typography className={`body2`} ml={1}>
                                        {tokenDetails?.token?.profile?.category?.name}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                        <Box my={2}>
                            <Typography fontWeight={700} className='title3'>
                                Price
                            </Typography>
                        </Box>
                        <Box mt={2}>
                            <TextField
                                size="small"
                                id="password"
                                className="w-100"
                                type="number"
                                onChange={(e) => { setAmount(e.target.value) }}
                                placeholder="Enter price"
                                InputProps={{
                                    endAdornment: <TextFieldAdornment value={currency}
                                        select={(value: string) => setCurrency(value)}
                                        items={CURRENCIES} />,
                                }}
                            />
                        </Box>

                        <Box my={2}>
                            <span className={classes.dark}>{getOtherCurrency(currency)} Eqiuvalent:</span> <strong> &nbsp;{convertedPrice}</strong>
                        </Box>
                        <Box my={2}>
                            <span className={classes.dark}>Stakes commission  </span>
                            <strong>{tokenDetails?.token?.commission_percentage}%</strong>
                        </Box>
                    </Card>
                </Grid>
                <Grid item md={4} xs={12}>
                    <Paper elevation={1} className={classes.summary}>
                        <Typography fontWeight={700} className='title3' color='#1E293B' mb={2}>
                            Summary
                        </Typography>
                        <Typography className='caption' color='#64748B' mb={1}>
                            Asking Price
                        </Typography>
                        <Box display='flex' flexDirection='row' mt={2}>
                            <Typography fontWeight={700} className='currency' color='#1E293B' mr={1}>
                                {tokenDetails?.token?.profile?.currency}
                            </Typography>
                            <Typography fontWeight={700} className='title2' color='#1E293B'>
                                {getCurrencySymbol(tokenDetails?.token?.profile?.currency)}{tokenDetails?.token?.listing_amount}
                            </Typography>
                        </Box>
                        <Box display="flex" justifyContent="start" mb={2} ml={8}>
                            <Typography className='caption' color='#64748B'>
                                {getOtherCurrency(tokenDetails?.token?.profile?.currency)}  {currencyConversion(getOtherCurrency(tokenDetails?.token?.profile?.currency), tokenDetails?.token?.listing_amount, appSlice.USD_TO_ETH_VALUE)}
                            </Typography>
                        </Box>

                        <Button variant="contained" className="w-100" onClick={() => onSubmit()} size="small" color="primary">Post your listing <KeyboardArrowRightIcon fontSize="small" /></Button>
                        <Box my={1} display="flex" justifyContent="space-between" >
                            <Box display="flex">
                                <Typography className={`body2`} color='#1E293B'>
                                    Commission Fee&nbsp;&nbsp;
                                </Typography>
                                <CustomTooltip title={commissionTooltip} placement="top">
                                    <img src={QuestionMakrImage} alt="Warning" />
                                </CustomTooltip>

                            </Box>
                            <Typography className={`body2`} color='#64748B'>
                                {getCurrencySymbol(tokenDetails?.token?.profile?.currency)} {getCommisionFee()}
                            </Typography>
                        </Box>
                        <Box my={1} display="flex" justifyContent="flex-end" >
                            <Typography className='caption' color='#64748B'>
                                {getOtherCurrency(tokenDetails?.token?.profile?.currency)}  {currencyConversion(getOtherCurrency(tokenDetails?.token?.profile?.currency), getCommisionFee(), appSlice.USD_TO_ETH_VALUE)}
                            </Typography>
                        </Box>
                        <Box my={1} display="flex" justifyContent="space-between" >
                            <Box display="flex">   <Typography className={`body2`} color='#1E293B'>
                                Transaction Fee &nbsp;&nbsp;
                            </Typography>
                                <CustomTooltip title={transactionFeeTooltip} placement="top">
                                    <img src={QuestionMakrImage} alt="Warning" />
                                </CustomTooltip>
                            </Box>
                            <Typography className={`body2`} color='#64748B'>
                                {getCurrencySymbol(tokenDetails?.token?.profile?.currency)} {getTransactionFee()}

                            </Typography>
                        </Box>
                        <Box my={1} display="flex" justifyContent="flex-end" >
                            <Typography className='caption' color='#64748B'>
                                {getOtherCurrency(tokenDetails?.token?.profile?.currency)}  {currencyConversion(getOtherCurrency(tokenDetails?.token?.profile?.currency), getTransactionFee(), appSlice.USD_TO_ETH_VALUE)}
                            </Typography>
                        </Box>
                        <Divider />
                        <Box my={1} display="flex" justifyContent="space-between" >
                            <Typography fontWeight={600} className={`body2`} color='#0F172A'>
                                Total
                            </Typography>
                            <Typography fontWeight={600} className={`body2`} color='#475569'>
                                {getCurrencySymbol(tokenDetails?.token?.profile?.currency)} {calculateAmount()}
                            </Typography>
                        </Box>
                        <Box my={1} display="flex" justifyContent="flex-end" >
                            <Typography className='caption' color='#64748B'>
                                {getOtherCurrency(tokenDetails?.token?.profile?.currency)}  {currencyConversion(getOtherCurrency(tokenDetails?.token?.profile?.currency), calculateAmount(), appSlice.USD_TO_ETH_VALUE)}
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>
                <Grid item md={1}></Grid>
            </Grid >
        </AppContainer>
    )
}
